import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export enum ModelDetailsTabs {
  Summary = 'Summary',
  Holdings = 'Holdings',
}

interface ModelDetailsConfig {
  activeTab: ModelDetailsTabs
}

interface ModelDetailsState {
  config: ModelDetailsConfig
  configVersion: string
  searchTerm: string
  selectedBond: string | null
}

const initialState: ModelDetailsState = {
  config: {
    activeTab: ModelDetailsTabs.Summary,
  },
  configVersion: '1.0',
  searchTerm: '',
  selectedBond: null,
}

const modelDetailsSlice = createSlice({
  name: 'modelDetails',
  initialState,
  reducers: {
    initializeModelDetailsConfig: (
      state,
      action: PayloadAction<{ config: ModelDetailsConfig; version: string }>,
    ) => {
      state.config = action.payload.config
      state.configVersion = action.payload.version
    },
    resetModelDetailsConfig: (state) => {
      state.config = initialState.config
      state.configVersion = initialState.configVersion
      state.searchTerm = initialState.searchTerm
      state.selectedBond = initialState.selectedBond
    },
    setModelDetailsConfig: (
      state,
      action: PayloadAction<ModelDetailsConfig>,
    ) => {
      state.config = action.payload
    },
    setActiveTab: (state, action: PayloadAction<ModelDetailsTabs>) => {
      state.config.activeTab = action.payload
    },
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload
    },
    setSelectedBond: (state, action: PayloadAction<string | null>) => {
      state.selectedBond = action.payload
    },
  },
})

export const { initializeModelDetailsConfig } = modelDetailsSlice.actions

// biome-ignore lint/style/noDefaultExport: Existing default export — prefer named exports for new code
export default modelDetailsSlice
